export function getUserAgent(platform: 'ios' | 'android', appVersion: string) {
  return `sweetgreen/${appVersion}; ${platform}; ${NATIVE_USER_AGENT_FALLBACKS[platform]}`;
}

export function identifyPlatform(userAgent: string): UserAgentPlatform {
  if (BRANDED_IOS_PATTERN.test(userAgent)) {
    return 'ios';
  }

  if (BRANDED_ANDROID_PATTERN.test(userAgent)) {
    return 'android';
  }

  if (LEGACY_IOS_PATTERN.test(userAgent)) {
    return 'ios';
  }

  if (LEGACY_ANDROID_PATTERN.test(userAgent)) {
    return 'android';
  }

  return 'web';
}

const NATIVE_USER_AGENT_FALLBACKS = {
  ios: 'CFNetwork; Darwin',
  android: 'OkHttp; Linux',
} as const;

const BRANDED_IOS_PATTERN = /sweetgreen\/[^;]+;\s*ios\b/i;
const BRANDED_ANDROID_PATTERN = /sweetgreen\/[^;]+;\s*android\b/i;
const LEGACY_IOS_PATTERN = /\bcfnetwork\b/i;
const LEGACY_ANDROID_PATTERN = /\bokhttp\b/i;

const USER_AGENT_PLATFORMS = ['ios', 'android', 'web', 'unknown'] as const;

export type UserAgentPlatform = (typeof USER_AGENT_PLATFORMS)[number];
